import React, { useEffect } from "react"
import { Badge, Card, CardBody, CardTitle, Col, Row, Table } from "reactstrap"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import Breadcrumbs from "components/Common/Breadcrumb"
import BackButton from "components/Shared/BackButton"
import { ShimmerThumbnail } from "react-shimmer-effects"
import { getRegionDetails } from "store/actions/regionAction"
import isPermissionEnabled from "common/isPermissionEnabled"
import { useTranslation } from "react-i18next"

const RegionDetails = () => {
  const { t } = useTranslation()

  document.title = t(`Region Details | Sign Burger`)

  const location = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const searchParams = new URLSearchParams(location.search)
  const id = searchParams.get("id")

  const { loading, isLoading, regionDetails } = useSelector(
    state => state.Region
  )

  const { userRole, accountType } = useSelector(state => state.Login)

  useEffect(() => {
    const isPermissionView = isPermissionEnabled(
      userRole,
      25,
      "region_1",
      accountType
    )
    if (!isPermissionView) {
      navigate("/dashboard")
    }
  }, [])

  useEffect(() => {
    const fetchOldDetails = () => {
      const payload = {
        id,
      }
      dispatch(getRegionDetails(payload))
    }
    fetchOldDetails()
  }, [])

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs />
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <CardTitle className="d-flex align-items-center">
                  <BackButton /> {t("Region Details")}
                </CardTitle>
                <p className="text-muted mb-4"></p>
                <div className="table-responsive">
                  {loading ? (
                    <ShimmerThumbnail height={650} rounded />
                  ) : Object.values(regionDetails).length === 0 ? (
                    <p className="text-center my-2">
                      {t("No region details found")}
                    </p>
                  ) : (
                    <Table className="table-nowrap mb-0 capitalize_td">
                      <tbody>
                        <tr>
                          <th scope="row">{t("Id")}</th>
                          <td>{regionDetails._id}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Name(English)")}</th>
                          <td>{regionDetails?.name}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Name(عربي)")}</th>
                          <td>{regionDetails?.nameAr}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Country Name(English)")}</th>
                          <td>{regionDetails?.country?.name}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Country Name(عربي)")}</th>
                          <td>{regionDetails?.country?.nameAr}</td>
                        </tr>

                        <tr>
                          <th scope="row">{t("Status")}</th>
                          <td>
                            {regionDetails?.status === 1 ? (
                              <Badge className="bg-success">
                                {t("Active")}
                              </Badge>
                            ) : (
                              <Badge className="bg-danger">
                                {t("Deactive")}
                              </Badge>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default RegionDetails
